/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import { IFlatLot } from '@vamstar/fox-api-common/esm/lot/types';
import lowerCase from 'lodash/lowerCase';
import upperFirst from 'lodash/upperFirst';

import { DslOperator } from './component/interface';

export type IFlatlotFields = keyof IFlatLot;

export interface IFlatLotKeyLabel {
  key: keyof IFlatLot;
  label: string;
}

export const FLATLOT_FIELDS: IFlatlotFields[] = [
  'noticeDerivedId',
  'externalId',
  'alternativeNoticeId',
  'contractValueCurrency',
  'buyerId',
  'buyerName',
  'buyerNameDerived',
  'buyerNameEnglishDerived',
  'buyerNameSource',
  'buyerAddress',
  'buyerTown',
  'buyerPostcode',
  'buyerCountry',
  'buyerContacts',
  'buyerEmails',
  'buyerMainUrl',
  'contractAuthority',
  'contractAuthorityMain',
  'contractActivity',
  'contractActivityMain',
  'contractNature',
  'contractRegulation',
  'contractBid',
  'contractDurationSource',
  'contractDurationType',
  'contractDuration',
  'entityOriginalLanguage',
  'contractCriteria',
  'lotProductSize',
  'lotProductUnit',
  'lotProductSizeAndUnit',
  'lotCpvCode',
  'lotCpvType',
  'lotCpv',
  'lotCriteriaQualityWeightConverted',
  'lotCriteriaPriceWeightConverted',
  'lotValueOriginal',
  'lotValueCurrency',
  'lotNuts',
  'lotProcurementDescription',
  'lotCriteriaQuality',
  'lotCriteriaQualityWeight',
  'lotCriteriaPrice',
  'lotCriteriaPriceWeight',
  'lotCriteriaPriceType',
  'lotDurationType',
  'lotDuration',
  'lotRenewal',
  'lotEuFunds',
  'lotAdditionalInformation',
  'contractCpvCode',
  'contractCpv',
  'contractValueSource',
  'contractValueAnomaly',
  'noticeType',
  'procedureTypeCode',
  'procedureType',
  'industry',
  'authorMapperEmail',
  'authorMapperDate',
  'authorLotMapperType',
  'authorLotMapperComment',
  'authorLotMapperEmail',
  'authorLotMapperDate',
  'debugSourceFileType',
  'debugEntityS3Bucket',
  'debugEntityS3Key',
  'debugFilePath',
  'debugParsedDate',
  'debugCreatedDate',
  'debugOldestCreatedDate',
  'debugLastUpdatedDate',
  'vamId',
  'noticeVamId',
  'entityIsoCountry',
  'noticeUrl',
  'publishedDate',
  'contractTitle',
  'contractDescription',
  'contractStartDate',
  'contractEndDate',
  'lotNumber',
  'lotTitle',
  'lotMedicalServiceOrigEn',
  'closeSubmissionDate',
];

export const NUMERICAL_FLATLOT_FIELDS: IFlatlotFields[] = [
  'contractValue',
  'totalNumberOfLots',
  'contractDurationDays',
  'lotValueEstimatedEur',
  'lotValue',
  'contractValueEstimatedEur',
  'lotValueEstimatedUsd',
  'contractValueEstimatedUsd',
  'contractDurationMonths',
  'lotQuantity',
];

export const DSL_OPERATOR_WITH_SPACING: DslOperator[] = ['AND', 'OR', 'TO'];

export const FLAT_LOT_LABELS: IFlatLotKeyLabel[] = [
  ...FLATLOT_FIELDS,
  ...NUMERICAL_FLATLOT_FIELDS,
].map<IFlatLotKeyLabel>((key) => ({
  key,
  label: upperFirst(lowerCase(key)),
}));

export const VALID_QUERY_HELPERS: DslOperator[] = ['[', ']', '!', 'AND', 'OR', 'TO'];
